import React from 'react';
import {Link} from 'react-router-dom';

import './izvestajlist.styles.css';
import IzvestajItem from  '../izvestajitem/izvestajitem.component';


const IzvestajList = props => {    
   if(props.items.length === 0 || !props.items){
       return (
           <div className="center-izvestaj-empty">
               <h2 className="empty-headline">Nema pronadjenih Izvestaja</h2>
               <img src="/img/hiker-man.png"  className="empty-icon"alt="Nema pronadjenih Izvestaja"  />
               <p className="empty-return"><Link to="/">Povratak na početnu stranicu </Link></p> 
               
           </div>
       )
   }
   return <ul className="row-izvestajs"> 
       {props.items.map(izvestaj => ( <IzvestajItem key={izvestaj.id} id={izvestaj.id} naslov={ izvestaj.naslov } opis={izvestaj.opis} datum={izvestaj.datum} 
       image={`${process.env.REACT_APP_ASSET_URL}/${izvestaj.image}`} /> ))}

   </ul>


};


export default IzvestajList;